import { Event } from '@/app/event-stream';

export const ObjectCompletedEventName = 'object-completed' as const;
export interface ObjectCompletedEvent {
  id: string;
}

export type ObjectEvent = Event<typeof ObjectCompletedEventName, ObjectCompletedEvent>;
